import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const relatedProgramsBlocks = document.querySelectorAll(
	'.block-related-programs'
);

if (relatedProgramsBlocks.length > 0) {
	const cardsPerLoad = 6;
	const gridBlocksArray = [];

	const loadMoreCards = (index) => {
		const { items, loadMoreButton, page, totalPages } =
			gridBlocksArray[index];

		for (let i = 0; i < cardsPerLoad; i++) {
			items[i + page * cardsPerLoad]?.classList.add('active');
		}

		gridBlocksArray[index].page++;

		if (page + 1 === totalPages) {
			loadMoreButton.setAttribute('hidden', 'true');
		}
	};

	relatedProgramsBlocks.forEach((block) => {
		const slider = block.querySelector('.swiper');

		if (slider) {
			const slides = block.querySelectorAll('.swiper-slide');
			const prevButton = block.querySelector('.swiper-button-prev');
			const nextButton = block.querySelector('.swiper-button-next');
			const slidesPerView = slides.length === 1 ? 2 : 3;

			new Swiper(slider, {
				modules: [A11y, Navigation],
				slidesPerView: 1,
				spaceBetween: 20,
				navigation: {
					prevEl: prevButton,
					nextEl: nextButton,
				},
				a11y: {
					itemRoleDescriptionMessage: 'slide',
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView,
						spaceBetween: 8,
					},
				},
			});

			return;
		}

		const items = block.querySelectorAll(
			'.block-related-programs__grid-item'
		);
		const loadMoreButton = block.querySelector(
			'.block-related-programs__load-more'
		);

		if (!loadMoreButton || items.length <= cardsPerLoad) {
			return;
		}

		const index = gridBlocksArray.length;

		gridBlocksArray.push({
			items,
			loadMoreButton,
			page: 1,
			totalPages: Math.ceil(items.length / cardsPerLoad),
		});

		loadMoreButton.removeAttribute('hidden');
		loadMoreButton.addEventListener('click', () => loadMoreCards(index));
	});
}
